<template>
  <v-container>
    <v-layout align-center justify-center row fill-height wrap>
      <v-flex sm12 xs12 md12 lg12 v-if="salesDay && salesDay.length > 0">
        <material-stats-card
          color="green"
          icon="shopping_cart"
          title="Total de Vendas"
          :value="salesDay.length.toString()"
          small-value="#"
          sub-icon="house_siding"
          sub-text="Total de vendas hoje"
        />
      </v-flex>
      <v-flex sm12 xs12 md12 lg12 v-if="salesDay && salesDay.length > 0">
        <material-stats-card
          color="blue"
          icon="shopping_cart"
          title="Suas Vendas"
          :value="totalSeller.length.toString()"
          small-value="#"
          sub-icon="house_siding"
          sub-text="Total de suas vendas hoje"
        />
      </v-flex>
      <v-flex
        sm12
        xs12
        md12
        lg12
        v-if="salesDay && salesDay.length > 0"
        style="position: relative; width: 80vw"
      >
        <!-- <div class="chart-container"> -->
        <!-- <canvas id="sales-charts"></canvas> -->
        <!-- </div> -->
        <div>Vendas por Vendedor</div>
        <v-data-table
          :headers="headers"
          :items="bySeller"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.seller }}</td>
            <td class="text-xs-right">{{ props.item.count }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
// import Chart from 'chart.js';

export default {
  computed: {
    ...mapState("sales", ["salesDay"]),
    ...mapGetters(["loggedUser"]),
    totalSeller() {
      if (!this.salesDay) return 0;
      return this.salesDay.filter((value) => {
        if (value.signedcontract_partner === this.loggedUser.email)
          return value;
      });
    },
    bySeller() {
      // console.log('bySeller: ', this.salesDay)
      if (!this.salesDay) return [];
      var counts = this.salesDay.reduce((p, c) => {
        var name = c.signedcontract_partner;
        if (!p.hasOwnProperty(name)) {
          p[name] = 0;
        }
        p[name]++;
        return p;
      }, {});

      // console.log(counts);

      var countsExtended = Object.keys(counts).map((k) => {
        return { seller: k, count: counts[k] };
      });

      // console.log(countsExtended);

      return countsExtended.sort(function (a, b) {
        return a.count < b.count ? 1 : a.count > b.count ? -1 : 0;
      });
    },
  },
  data: () => ({
    loading: false,
    headers: [
      {
        text: "Vendedor",
        align: "left",
        sortable: false,
        value: "seller",
      },
      {
        text: "Qtde Vendas",
        align: "left",
        sortable: false,
        value: "count",
      },
    ],
  }),
  mounted() {
    // console.log('mounted: ', this.salesDay)
    if (this.salesDay && this.salesDay.length === 0) {
      this.getSalesDay();
    }
  },
  methods: {
    ...mapActions("sales", ["getSalesDay"]),
  },
};
</script>
